// LeaderboardUserCard.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import UserStatusIndicator from '../container/UserStatusIndicator.js';
import UserAvatarWithStatus from '../container/UserAvatarWithStatus.js';
import AvatarPlaceholder from '../../img/placeholder-avatar-cube-60.svg';
import trackMixpanel, {
  EventTypes,
  getViewId,
  ButtonId,
} from '../resource/mixpanel.js';

import { MediaAssetFormat } from '../resource/getMediaAsset.js';

const srcSet = [
  MediaAssetFormat.AVIF,
  MediaAssetFormat.WEBP,
  MediaAssetFormat.JPG,
]
  .map(format => {
    return [
      { size: 128, resolution: '1x' },
      { size: 256, resolution: '2x' },
    ].map(size => ({ ...size, ext: format }));
  })
  .flatMap(a => a);

export class LeaderboardUserCard extends React.PureComponent {
  renderUserAvatar = () => {
    const { userId } = this.props;
    return (
      <AvatarWrapper>
        <UserAvatarWithStatus
          id={userId}
          size={92}
          srcSet={srcSet}
          shouldTrackEvent={false}
          onClick={this.trackUserClick}
        />
      </AvatarWrapper>
    );
  };
  componentDidMount() {
    const { userId, username, fetchUser } = this.props;
    if (userId && !username) {
      this.fetchUserTimeout = setTimeout(() => fetchUser(userId));
    }
  }
  componentWillUnmount() {
    clearTimeout(this.fetchUserTimeout);
  }
  trackUserClick = args => {
    const { category, index, username, region, range } = this.props;
    return trackMixpanel({
      type: EventTypes.USER_CLICKED,
      payload: {
        viewId: getViewId({ pathname: window.location.pathname }),
        buttonId: ButtonId.Home.ButtonHomeLeaderboardCard,
        extraProps: {
          'leaderboard.tab': category,
          'leaderboard.rank': index + 1,
          'leaderboard.region': region,
          'leaderboard.range': range,
          'user.username': username,
          ...args,
        },
      },
    });
  };
  render() {
    const { userId, index, username } = this.props;
    return (
      <StyledLeaderboardUserCard>
        <AvatarSection>
          {userId ? (
            this.renderUserAvatar()
          ) : (
            <DefaultAvatarWrapper>
              <img
                src={AvatarPlaceholder}
                alt="avatar placeholder"
                width="92"
                height="92"
              />
            </DefaultAvatarWrapper>
          )}
        </AvatarSection>
        <PlaceSection>{index + 1}</PlaceSection>
        <UsernameSection>
          <Username>@{username}</Username>
          <UserStatusIndicatorWrapper>
            <UserStatusIndicator
              userId={userId}
              livestreamSize={12}
              shouldShowOnline
              shouldShowLiveStream
            />
          </UserStatusIndicatorWrapper>
        </UsernameSection>
      </StyledLeaderboardUserCard>
    );
  }
}

LeaderboardUserCard.propTypes = {
  category: PropTypes.string,
  userId: PropTypes.string,
  index: PropTypes.number,
  username: PropTypes.string,
  fetchUser: PropTypes.func,
  region: PropTypes.string,
  range: PropTypes.string,
};

LeaderboardUserCard.defaultProps = {
  category: '',
  userId: '',
  index: null,
  username: null,
  fetchUser: () => null,
  region: null,
  range: null,
};

const StyledLeaderboardUserCard = styled.div`
  position: relative;
  padding-top: 6px;
  overflow: hidden;
`;

const AvatarSection = styled.div``;

const AvatarWrapper = styled.div`
  border-radius: 50px;
  display: flex;
  justify-content: center;
`;

const PlaceSection = styled.div`
  position: absolute;
  left: 0;
  bottom: 22px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.79);
  -webkit-text-stroke: 2px #fff;
  font-size: 52px;
  font-weight: 600;
  font-style: italic;
`;

const DefaultAvatarWrapper = styled.div`
  > img {
    border-radius: 50%;
  }
  display: flex;
  justify-content: center;
`;

const UsernameSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
`;

const Username = styled.div`
  font-size: 12px;
`;

const UserStatusIndicatorWrapper = styled.div`
  margin-left: 2px;
`;

export default LeaderboardUserCard;
